import React, { Component } from 'react';
import "./RestrictedInput.css";

class RestrictedInput extends Component {

    props = {
        placeholderText: "",
        onTextChange: function() {},
        paragraphs: []
    }

    state = {
        isBackspaceAllowed: false
    }

    handleKeyPress = (event) => {
        const paragraphs = this.props.paragraphs.slice();
        const key = event.key;
        if (this.isBlank()) {
            paragraphs.push(key);
        } else if (key === 'Enter') {
            paragraphs.push('');
        } else {
            const lastParagraph = paragraphs.pop();
            paragraphs.push(lastParagraph + key);
        }
        this.setState({
            isBackspaceAllowed: true
        });
        this.props.onTextChange({ paragraphs });
    }

    handleKeyDown = (event) => {
        const paragraphs = this.props.paragraphs.slice();
        const key = event.key;
        if (key === "Backspace" && this.state.isBackspaceAllowed) {
            const lastParagraph = paragraphs.pop();
            if (lastParagraph.length > 0) {
                const lastChar = lastParagraph.slice(-1);
                const lastParagraphWithoutLastChar = lastParagraph.slice(0, lastParagraph.length - 1);
                paragraphs.push(lastParagraphWithoutLastChar);
                if (lastChar !== ' ' || lastParagraphWithoutLastChar.slice(-1) !== ' ') {
                    this.setState({
                        isBackspaceAllowed: false
                    });
                }
            } else {
                this.setState({
                    isBackspaceAllowed: false
                });
            }
        }
        this.props.onTextChange({ paragraphs });
    }

    componentWillMount() {
        window.addEventListener('keypress', this.handleKeyPress);
        window.addEventListener('keydown', this.handleKeyDown);
    }
    
    componentWillUnmount() {
        window.removeEventListener('keypress', this.handleKeyPress);
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    render() {
        const className = this.isBlank()
            ? "tw-restricted-input tw-restricted-input-blank"
            : "tw-restricted-input";
        return (
            <article className={className}>
                { this.isBlank() ? this.renderBlank() : this.props.paragraphs.map(this.renderParagraph) }
            </article>
        );
    }

    renderBlank() {
        return <p>{this.props.placeholderText}</p>
    }

    renderParagraph(paragraphText, index) {
        return <p key={ index }>{ paragraphText }</p>
    }

    isBlank() {
        return this.props.paragraphs.length === 0;
    }
}

export default RestrictedInput;



// WEBPACK FOOTER //
// ./src/restricted-input/RestrictedInput.js